import {
  GET_CONNECTED_ACCOUNTS_CONFIG,
  GET_CONNECTED_ACCOUNTS_CONFIG_FAILED,
  GET_CONNECTED_ACCOUNTS_CONFIG_SUCCESS,
  GET_CONNECTED_ACCOUNTS_LIST,
  GET_CONNECTED_ACCOUNTS_LIST_FAILED,
  GET_CONNECTED_ACCOUNTS_LIST_SUCCESS,
  RESET_CONNECTED_ACCOUNTS_CONFIG,
  RESET_CONNECTED_ACCOUNTS_LIST,
  SAVE_PAYOUTS,
  SAVE_PAYOUTS_SUCCESS,
  SAVE_PAYOUTS_FAILED,
  SET_STRIPE_MAIN_ACCOUNT,
  SET_STRIPE_MAIN_ACCOUNT_SUCCESS,
  SET_STRIPE_MAIN_ACCOUNT_FAILED,
  DISCONNECT_STRIPE_ACCOUNT,
  DISCONNECT_STRIPE_ACCOUNT_SUCCESS,
  DISCONNECT_STRIPE_ACCOUNT_FAILED,
  OPEN_DISCONNECT_STRIPE_ACCOUNT_MODAL,
  HIDE_DISCONNECT_STRIPE_ACCOUNT_MODAL,
  GET_STRIPE_CONNECTED_ACCOUNT,
  GET_STRIPE_CONNECTED_ACCOUNT_SUCCESS,
  GET_STRIPE_CONNECTED_ACCOUNT_FAILED,
} from "./actionTypes"

export const getConnectedAccountsConfig = params => ({
  type: GET_CONNECTED_ACCOUNTS_CONFIG,
  payload: params,
})

export const getConnectedAccountsConfigSuccess = response => ({
  type: GET_CONNECTED_ACCOUNTS_CONFIG_SUCCESS,
  payload: response,
})

export const getConnectedAccountsConfigFailed = error => ({
  type: GET_CONNECTED_ACCOUNTS_CONFIG_FAILED,
  payload: error,
})

export const resetConnectedAccountsConfig = () => ({
  type: RESET_CONNECTED_ACCOUNTS_CONFIG,
  payload: {},
})

export const getConnectedAccountsList = params => ({
  type: GET_CONNECTED_ACCOUNTS_LIST,
  payload: params,
})

export const getConnectedAccountsListSuccess = response => ({
  type: GET_CONNECTED_ACCOUNTS_LIST_SUCCESS,
  payload: response,
})

export const getConnectedAccountsListFailed = error => ({
  type: GET_CONNECTED_ACCOUNTS_LIST_FAILED,
  payload: error,
})

export const resetConnectedAccountsList = () => ({
  type: RESET_CONNECTED_ACCOUNTS_LIST,
  payload: {},
})

export const savePayouts = params => ({
  type: SAVE_PAYOUTS,
  payload: params,
})

export const savePayoutsSuccess = response => ({
  type: SAVE_PAYOUTS_SUCCESS,
  payload: response,
})

export const savePayoutsFailed = error => ({
  type: SAVE_PAYOUTS_FAILED,
  payload: error,
})

export const setStripeMainAccount = (values, callback) => ({
  type: SET_STRIPE_MAIN_ACCOUNT,
  payload: { values, callback },
})

export const setStripeMainAccountSuccess = response => ({
  type: SET_STRIPE_MAIN_ACCOUNT_SUCCESS,
  payload: response,
})

export const setStripeMainAccountFailed = error => ({
  type: SET_STRIPE_MAIN_ACCOUNT_FAILED,
  payload: error,
})

export const disconnectStripeAccount = params => ({
  type: DISCONNECT_STRIPE_ACCOUNT,
  payload: params,
})

export const disconnectStripeAccountSuccess = response => ({
  type: DISCONNECT_STRIPE_ACCOUNT_SUCCESS,
  payload: response,
})

export const disconnectStripeAccountFailed = error => ({
  type: DISCONNECT_STRIPE_ACCOUNT_FAILED,
  payload: error,
})

export const openDisconnectStripeAccountModal = () => ({
  type: OPEN_DISCONNECT_STRIPE_ACCOUNT_MODAL,
  payload: {},
})

export const hideDisconnectStripeAccountModal = () => ({
  type: HIDE_DISCONNECT_STRIPE_ACCOUNT_MODAL,
  payload: {},
})

export const getStripeConnectedAccount = params => ({
  type: GET_STRIPE_CONNECTED_ACCOUNT,
  payload: params,
})

export const getStripeConnectedAccountSuccess = response => ({
  type: GET_STRIPE_CONNECTED_ACCOUNT_SUCCESS,
  payload: response,
})

export const getStripeConnectedAccountFailed = error => ({
  type: GET_STRIPE_CONNECTED_ACCOUNT_FAILED,
  payload: error,
})
